import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('supplier'),
  all_suppliers: []
}

const getters = {
  ...restful.getters('supplier'),
  all_suppliers: (state) => state.all_suppliers
}

const actions = {
  ...restful.actions('suppliers'),
  async allSuppliers ({ commit }) {
    const res = await axios.get('suppliers?per=10000')
    commit('all_suppliers', res.data)
  }
}

const mutations = {
  ...restful.mutations('supplier'),
  all_suppliers (state, all_suppliers) {
    state.all_suppliers = all_suppliers
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
